import { BuilderTableViewColumn } from '../../types/builderTableView.js';
import { Dimension } from '../../types/campaignBuilder.js';
import { DimensionsGroup, ResponseItems } from './EditModal.types.js';

export const isUnique = (value: string, values: string[]): boolean =>
  values.indexOf(value) === values.lastIndexOf(value);

export const prepareBuilderSchema = (
  builderSchema: ResponseItems,
): DimensionsGroup[] =>
  builderSchema.map((groupItem) => ({
    label: groupItem.label,
    dimensions: groupItem.dimensions.map((item) => ({
      name: item.label,
      value: item.name,
    })),
  }));

export const floatGroupItems = (
  dimensionsGroups: DimensionsGroup[],
): Dimension[] =>
  dimensionsGroups.reduce(
    (acc, dimensionsGroup) => [...acc, ...dimensionsGroup.dimensions],
    [] as Dimension[],
  );

export const prepareCampaignColumns = (columns: BuilderTableViewColumn[]) =>
  columns.map((column) => ({
    name: column.label,
    value: column.name,
  }));

export const updateCurrentDimensions = (
  currentDimensions: Dimension[],
  availableDimensions: Dimension[],
): Dimension[] =>
  currentDimensions
    .filter((currentDimension) =>
      availableDimensions.find(
        (availableDimension) =>
          availableDimension.value === currentDimension.value,
      ),
    )
    .map((currentDimension) => ({
      name:
        availableDimensions.find(
          (availableDimension) =>
            currentDimension.value === availableDimension.value,
        )?.name ?? '',
      value: currentDimension.value,
    }));
